import { useEffect, useState } from "react";
import { IconSelectRightArrow } from "../icon/master";

interface TDropDownItem {
	id: string | number;
	value: string | number;
}
export function Dropdown(props: {
	options: Array<TDropDownItem>;
	defaultSelected: TDropDownItem;
	wrapClass?: string;
	onSelect: (selectedItem: TDropDownItem) => void;
	disableChangeSelected?: boolean;
}) {
	const { options, defaultSelected, wrapClass = "", onSelect, disableChangeSelected = false } = props;
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState(defaultSelected);

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				window.addEventListener("click", CloseDropdown);
			});
		}
		return () => {
			window.removeEventListener("click", CloseDropdown);
		};
	}, [open]);
	const CloseDropdown = () => {
		setOpen(false);
		window.removeEventListener("click", CloseDropdown);
	};

	const selectHandle = (selectItem: TDropDownItem) => {
		setOpen(!open);
		if (selected.id !== selectItem.id) {
			if (!disableChangeSelected){
				setSelected(selectItem);
			}
			onSelect(selectItem);
		}
	};

	return (
		<>
			<div
				className={
					open
						? `dropdown-wrapper ${wrapClass} open`
						: `dropdown-wrapper ${wrapClass}`
				}
			>
				<div
					className="selected"
					onClick={() => {
						setOpen(!open);
					}}
				>
					<span className="text">{selected.value}</span>
					<IconSelectRightArrow />
				</div>

				<div className="dropdown-list">
					<div className="dropdown-list-wrapper">
						{options.map((item: any) => {
							return (
								<div
									key={item.id}
									className="item"
									onClick={() => {
										selectHandle(item);
									}}
								>
									{item.value}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
}
